import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, mergeClasses, Spinner, Text } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React, { JSX } from 'react';
import { useCommonStyles } from '../../common/hooks';

interface ConfirmationDialogProps {
  isOpen: boolean;
  isLoading?: boolean;
  isShowCloseDialog?: boolean;
  className?: string;
  dialogTitle?: string;
  dialogSubtext?: JSX.Element | string;
  primaryButtonLabel: string;
  onPrimaryButtonClick: () => void;
  secondaryButtonLabel?: string;
  onSecondaryButtonClick?: () => void;
  onCloseDialogClick?: () => void;
}

const ConfirmationDialogImpl: React.FC<ConfirmationDialogProps> = (props) => {
  const {
    isOpen,
    isLoading = false,
    isShowCloseDialog = true,
    className = '',
    dialogTitle,
    dialogSubtext,
    primaryButtonLabel,
    secondaryButtonLabel,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    onCloseDialogClick,
  } = props;

  const commonStyles = useCommonStyles();

  return (
    <Dialog
      open={isOpen}
    >
      <DialogSurface
        className={mergeClasses(commonStyles.modalSurface, `confirmation-dialog ${className}`)}
      >
        <DialogBody
          className={commonStyles.modalBody}
        >
          <DialogTitle
            action={isShowCloseDialog ? (
              <Button
                title='close'
                appearance='transparent'
                icon={<DismissRegular />}
                onClick={onCloseDialogClick}
              />
            ) : null}
          >
            {dialogTitle}
          </DialogTitle>
          {
            !!dialogSubtext && (
              <DialogContent>
                {
                  typeof dialogSubtext === 'string' ? (
                    <Text
                      as='p'
                    >
                      {dialogSubtext}
                    </Text>
                  ) : (
                    dialogSubtext
                  )
                }
              </DialogContent>
            )
          }

          <DialogActions
            className='buttons'
          >
            {
              secondaryButtonLabel && onSecondaryButtonClick && (
                <Button
                  appearance='secondary'
                  onClick={onSecondaryButtonClick}
                  autoFocus
                >
                  {secondaryButtonLabel}
                </Button>
              )
            }
            <Button
              appearance='primary'
              onClick={onPrimaryButtonClick}
              icon={isLoading ? <Spinner size='extra-tiny' /> : null}
              disabled={isLoading}
            >
              {primaryButtonLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog >
  );
};

export const ConfirmationDialog = observer(ConfirmationDialogImpl);
